import { useQuery } from "@tanstack/react-query";
import { getImportedProfileCounts } from "@/app/actions/imported-profiles/action";
import { Globals } from "@/app/vars/Globals";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchImportedProfileCounts(
  options: { avatarId?: number; enabled?: boolean; refetchOnWindowFocus?: boolean } = {},
) {
  const { avatarId, enabled = true, refetchOnWindowFocus = true } = options;

  return useQuery({
    queryKey: [QueryKey.SOCIAL_IMPORTED_PROFILE_COUNTS, avatarId],
    queryFn: () => getImportedProfileCounts(avatarId!),
    enabled: enabled && !!avatarId,
    // The extension imports connections out-of-band; refresh on tab focus so the
    // imported count updates on return, throttled by staleTime.
    staleTime: Globals.PROSPECT_FRESHNESS_STALE_TIME_MS,
    refetchOnWindowFocus,
  });
}
